import React, { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Navigation } from "../components/Navigation";
import { Hero } from "../components/Hero";
import { EnvelopePreview } from "../components/EnvelopePreview";
import { Trust } from "../components/Trust";
import { CapsuleForm } from "../components/CapsuleForm";
import { EchoesGallery } from "../components/EchoesGallery";
import { PhilosophyContrast } from "../components/PhilosophyContrast";
import { Story } from "../components/Story";
import { Footer } from "../components/Footer";
import { api } from "../lib/api";

export default function HomePage() {
  const formRef = useRef(null);
  const { i18n } = useTranslation();
  const [duration, setDuration] = useState(365);

  useEffect(() => {
    document.documentElement.setAttribute("lang", i18n.language);
  }, [i18n.language]);

  useEffect(() => {
    // Count one visit per browser session for conversion-rate analytics
    if (sessionStorage.getItem("mp-visited")) return;
    sessionStorage.setItem("mp-visited", "1");
    api.post("/track/visit", { language: i18n.language }).catch(() => {});
  }, [i18n.language]);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div data-testid="home-page">
      <Navigation onWrite={scrollToForm} />
      <Hero onCta={scrollToForm} />
      <EnvelopePreview duration={duration} />
      <Trust />
      <CapsuleForm ref={formRef} duration={duration} onDurationChange={setDuration} />
      <EchoesGallery />
      <PhilosophyContrast />
      <Story />
      <Footer />
    </div>
  );
}
